<template>
    <template v-if="(missionEvents && missionEvents.length > 0) || viewCurrentMissionEvents">
        <l-marker v-for="evt in missionEvents" :key="evt.event_id" :title="evt.event_id"
            :lat-lng="[evt.location.coordinates[1], evt.location.coordinates[0]]" @click="selectMarker(evt.event_id)">
            <l-icon :icon-size="iconSize" :icon-anchor="iconAnchor" class-name="point-event">
                <span class="point-head">{{ evt.event_unit + ' ' + evt.event_number }}</span>
                <div class="point-icon">
                    <span>{{ evt.scope?.substring(0, 1) }}</span>
                    <img class="icono" :src="'/images/event_type_' + getTypeId(evt.type) + '.png'"
                        :alt="'Event type ' + evt.type" />
                </div>
            </l-icon>
            <l-tooltip>
                {{ evt.type }}<br />
                {{ evt.utc }}
            </l-tooltip>
        </l-marker>
    </template>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '@/stores/global'
import { useServicesStore } from '@/stores/services'
import { LMarker, LIcon, LTooltip } from "@vue-leaflet/vue-leaflet"
import { ref } from 'vue'

const global = useGlobalStore()
const serv = useServicesStore()
const { missionEvents, viewCurrentMissionEvents } = storeToRefs(global)
const { eventTypes } = storeToRefs(serv)

const iconSize = ref<[number, number]>([35, 35])
const iconAnchor = ref<[number, number]>([16, 37])

const emit = defineEmits<{
    (e: 'eventSelected', eventId: number): void
}>()

function getTypeId(type: string) {
    let tipoEvento = eventTypes.value.find((tipo) => tipo.event_type === type)
    return tipoEvento ? tipoEvento.event_type_id : 5
}

function selectMarker(eventId: number) {
    emit('eventSelected', eventId)
}
</script>

<style scoped>
.point-head {
    background-color: #d1b31ed9;
    display: block;
    font-size: 8px;
    text-align: center;
}

.point-icon {
    position: relative;
    border-radius: 10px 0;
    overflow: hidden;
    height: 25px;
}

.icono {
    width: 32px;
    height: 32px;
}
</style>